import { render, staticRenderFns } from "./Detections.vue?vue&type=template&id=181fe2dc&scoped=true&"
import script from "./Detections.vue?vue&type=script&lang=js&"
export * from "./Detections.vue?vue&type=script&lang=js&"
import style0 from "./Detections.vue?vue&type=style&index=0&id=181fe2dc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181fe2dc",
  null
  
)

export default component.exports